import { ISideBar } from '@/types/types';

export const links: { [key: string]: Array<ISideBar | { label: string }> } = {
  home: [
    {
      label: 'General',
    },
    {
      link: 'dashboard',
      icon: 'grid_view',
      text: 'Home',
      isLocked: false,
    },
    {
      link: 'products',
      icon: 'inventory_2',
      text: 'Products',
      isLocked: false,
    },
    {
      label: 'USSD',
    },
    {
      link: 'ussd.service.codes',
      icon: 'tag',
      text: 'Service Codes',
      isLocked: false,
    },
    {
      link: 'ussd.hits',
      icon: 'leaderboard',
      text: 'Hit Reports',
      isLocked: false,
    },
    {
      link: 'ussd.sessions',
      icon: 'sensors',
      text: 'Active Sessions',
      isLocked: false,
    },
    {
      label: 'Payments',
    },
    {
      link: 'payments',
      icon: 'payments',
      text: 'Transactions',
      isLocked: false,
    },
    {
      link: 'payments.merchants',
      icon: 'storefront',
      text: 'Merchants',
      isLocked: false,
    },
    {
      link: 'payments.callbacks',
      icon: 'webhook',
      text: 'Callbacks',
      isLocked: false,
    },
    {
      link: 'commissions',
      icon: 'trending_up',
      text: 'Commissions',
      isLocked: false,
    },
    {
      label: 'Analytics',
    },
    {
      link: 'analytics.daily-successful',
      icon: 'query_stats',
      text: 'Daily Successful',
      isLocked: false,
    },
    {
      link: 'analytics.top-organizations',
      icon: 'leaderboard',
      text: 'Top Organizations',
      isLocked: false,
    },
    {
      link: 'analytics.ussd-hits',
      icon: 'dialpad',
      text: 'USSD Hits',
      isLocked: false,
    },
    {
      link: 'analytics.overview',
      icon: 'donut_small',
      text: 'Daily Overview',
      isLocked: false,
    },
    {
      link: 'bills',
      icon: 'request_quote',
      text: 'Bill Mgmt',
      isLocked: true,
    },
    {
      link: 'newsletters',
      icon: 'campaign',
      text: 'Newsletters',
      isLocked: true,
    },
    {
      label: 'Tickets',
    },
    {
      link: 'tickets',
      icon: 'support_agent',
      text: 'All Tickets',
      isLocked: true,
    },
    {
      label: 'ACL',
    },
    {
      link: 'archives',
      icon: 'verified_user',
      text: 'Roles',
      isLocked: true,
    },
    {
      link: 'archives',
      icon: 'group',
      text: 'User Mgmt',
      isLocked: true,
    },
    {
      label: 'Settings',
    },
    {
      link: 'archives',
      icon: 'notifications_active',
      text: 'Notifications',
      isLocked: true,
    },
    {
      label: 'Help Center',
    },
    {
      link: 'archives',
      icon: 'forum',
      text: 'Feedback',
      isLocked: true,
    },
    {
      link: 'archives',
      icon: 'pest_control',
      text: 'Bug Reports',
      isLocked: true,
    },
  ],
  sms: [
    {
      label: 'General',
    },
    {
      link: 'sms.dashboard',
      icon: 'insights',
      text: 'Dashboard',
      isLocked: false,
    },
    {
      link: 'sms.customers',
      icon: 'groups',
      text: 'Customers',
      isLocked: false,
    },
    {
      link: 'sms.sender-id.all',
      icon: 'verified',
      text: 'Sender IDs',
      isLocked: false,
    },
    {
      label: 'Transactions',
    },
    {
      link: 'sms.transactions',
      icon: 'repeat',
      text: 'All Transactions',
      isLocked: false,
    },
    {
      label: 'Logs Mgmt',
    },
    {
      link: 'sms.logs',
      icon: 'list_alt',
      text: 'All Logs',
      isLocked: false,
    },
  ],
  cu: [
    {
      label: 'General',
    },
    {
      link: 'cu.dashboard',
      icon: 'analytics',
      text: 'Dashboard',
      isLocked: false,
    },
    {
      link: 'cu.customers',
      icon: 'storefront',
      text: 'Businesses',
      isLocked: false,
    },
    {
      label: 'Reports',
    },
    {
      link: 'cu.transactions',
      icon: 'sync_alt',
      text: 'Transactions',
      isLocked: false,
    },
    {
      link: 'cu.settlement-reports',
      icon: 'summarize',
      text: 'Settlement Reports',
      isLocked: false,
    },
    {
      link: 'cu.ussd.access-counts',
      icon: 'data_usage',
      text: 'USSD Access Count',
      isLocked: false,
    },
    {
      label: 'Autocrediting',
    },
    {
      link: 'cu.autocredit-pending-review',
      icon: 'rule',
      text: 'Pending Review',
      isLocked: false,
    },
    {
      link: 'cu.autocredit-processed',
      icon: 'fact_check',
      text: 'Processed',
      isLocked: false,
    },
    {
      link: 'cu.autocredit-bank-details',
      icon: 'account_balance',
      text: 'Bank Details',
      isLocked: false,
    },
  ],
};

export const findNavigationLink = (key: string) => {
  return links[key];
};
